<template>
  <div class="product2boxMd" :style="styleVar">
    <div class="product2boxWal">
      <h3>{{typicalApplication.title}}</h3>
      <div class="wrapperList" v-for="(item,index) in typicalApplication.items" :key="index">
        <div class="wrapperItem" v-if="index%2==0">
          <div class="wrapperMd">
            <img class="dxyyImages" :src="item.imgSrc" />
          </div>
          <div class="wrapperMd wrapperf">
            <div class="wrapperf_tit1">{{item.title}}</div>
            <a :href="item.route" target="_blank">
              <div class="wrapperf_tit2">查看更多</div>
            </a>
          </div>
        </div>
        <div class="wrapperItem" v-else>
          <div class="wrapperMd wrapperf">
            <div class="wrapperf_tit1">{{item.title}}</div>
            <a :href="item.route" target="_blank">
              <div class="wrapperf_tit2">查看更多</div>
            </a>
          </div>
          <div class="wrapperMd">
            <img class="dxyyImages" :src="item.imgSrc" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: {
      type: Object,
      default: () => { },
    },
  },
  computed: {
    unitObjData() {
      return Object.assign(
        {
          initBack: '#FFFFFF',
          initColor: '#F6F7F8',
        },
        this.initData
      );
    },
    styleVar() {
      const { initBack, initColor } = this.unitObjData;
      let html = {
        '--bginitBack': initBack,
        '--bginitColor': initColor,
      };
      return html;
    },
  },
  data() {
    return {
      typicalApplication: {
        title: '典型应用',
        items: [
          { imgSrc: require('@/assets/product/dxyy_1.png'), title: '北斗短报文手持机', route: "http://www.tiandiweitong.com/pb20b.html" },
          { imgSrc: require('@/assets/product/dxyy_2.png'), title: '北斗蓝牙便携终端', route: "http://www.tiandiweitong.com/pd18.html" },
          { imgSrc: require('@/assets/product/dxyy_3.png'), title: '北斗车载终端', route: "http://www.tiandiweitong.com/pd22.html" },
          // { imgSrc: require('@/assets/product/dxyy_4.png'), title: '军用保密通信产品', route: "http://www.tiandiweitong.com/pd15.html" },
          // { imgSrc: require('@/assets/product/dxyy_5.png'), title: '其他语音通信产品', route: "http://www.tiandiweitong.com/pd08.html" },
        ]
      },
    }
  }
};
</script>

<style lang="scss" scoped>
.product2boxMd {
  background: var(--bginitBack);
  position: relative;
  padding: 70px 0;

  .product2boxWal {
    width: 1200px;
    margin: 0 auto;
    position: relative;
  }

  h3 {
    text-align: center;
    font-size: 28px;
    font-weight: 400;
    color: #0d0e24;
    margin-bottom: 60px;
  }
}

.wrapperList {
  width: 100%;

  .wrapperItem {
    width: 100%;
    display: flex;

    .wrapperMd {
      width: 600px;
      height: 320px;
      background: var(--bginitColor);
      overflow: hidden;

      .dxyyImages {
        width: 600px;
        height: 320px;

        &:hover {
          transition: all .5s;
          transform: scale(1.05);
        }
      }
    }

    .wrapperf {
      display: flex;
      flex-direction: column;
      align-items: center;

      .wrapperf_tit1 {
        margin-top: 105px;
        font-size: 28px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #0D0E24;
      }

      a {
        text-decoration: none;
      }

      .wrapperf_tit2 {
        cursor: pointer;
        margin-top: 40px;
        width: 176px;
        height: 40px;
        border: 1px solid #4173FB;
        border-radius: 20px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #4173FB;
        text-align: center;
        line-height: 40px;
      }
    }
  }
}
</style>